import { render, staticRenderFns } from "./ik-word.vue?vue&type=template&id=67cb7c75&scoped=true&"
import script from "./ik-word.vue?vue&type=script&lang=js&"
export * from "./ik-word.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cb7c75",
  null
  
)

export default component.exports